import React from "react";
import styles from "./footerSave.module.css";
import classNames from "classnames";
import { useSelector } from "react-redux";
import { selectLoadingUI } from "../../reducers/uiSlice";
import { CircularProgress } from "@material-ui/core";
const FooterSave = ({ handleCancel, handleHomeSave, customLoading = false }) => {
  const loading = useSelector(selectLoadingUI);
  return (
    <div className={styles.footerGridContainer}>
      <div className={styles.footerGridContainerInner}>
        <p className={styles.footerInformation}>
          No olvides guardar tus cambios y espera alrededor de unos 5 minutos
          para verse reflejado en tu página web.
        </p>
      </div>
      <div className={styles.footerGridContainerInner}>
        <button
          onClick={handleCancel}
          className={classNames("btn", styles.footerCancelButton)}
          disabled={loading || customLoading}
        >
          Cancelar
        </button>
        <button
          disabled={loading || customLoading}
          onClick={handleHomeSave}
          className={classNames("btn", styles.footerSaveButton)}
        >
          {customLoading || loading ? <CircularProgress style={{ color: "white", width: "20px", height: "20px" }} /> : "Guardar"}
        </button>
      </div>
    </div>
  );
};

export default FooterSave;
